var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpHeaderType, HttpMethodType } from '../enums';
import { EnvironmentService } from './EnvironmentService';
import { handleResponse, handleResponseURL } from './FetchWrapperHelper';
import { convertBlobToBase64 } from './FileUtils';
import { MimeTypeService } from './MimeTypeService';
export class EnterpriseDocStoreService {
    /*istanbul ignore next*/
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
        this.env = EnvironmentService.getEnvironment();
    }
    postCreationRequest(edsRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!edsRequest.mimeType) {
                edsRequest.mimeType = MimeTypeService.lookup(edsRequest.documentName);
            }
            const url = `${this.env.enterpriseDocStoreEndpoint}/documents/creation-request?ep-eds-accessmode=EXTERNAL`;
            const requestPayload = {
                applicationName: edsRequest.applicationName,
                companyCode: edsRequest.companyCode,
                documentName: edsRequest.documentName,
                documentSizeInBytes: edsRequest.documentSizeInBytes,
                mimeType: edsRequest.mimeType
            };
            return this.postEdsRequest(url, requestPayload, edsRequest, 'application/vnd.mitchell.docstore.document.creation.request+json');
        });
    }
    postFileMetadata(edsRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.env.enterpriseDocStoreEndpoint}/metadata?ep-eds-accessmode=EXTERNAL`;
            const requestPayload = {
                applicationName: edsRequest.applicationName,
                applicationVersion: edsRequest.applicationVersion,
                createRequestId: edsRequest.createRequestId,
                createdBy: edsRequest.createdBy,
                documentName: edsRequest.documentName,
                duplicateDocumentAllowed: edsRequest.duplicateDocumentAllowed,
                documentSizeInBytes: edsRequest.documentSizeInBytes,
                md5: edsRequest.md5,
                mitchellDocCategory: edsRequest.mitchellDocCategory,
                mitchellModule: edsRequest.mitchellModule,
                ttlInDays: edsRequest.ttlInDays
            };
            return this.postEdsRequest(url, requestPayload, edsRequest, 'application/vnd.mitchell.docstore.metadata.request+json');
        });
    }
    /*istanbul ignore next*/
    getFileBlob(docUid, fetchWindow = window.fetch) {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchWindow(this.getFileUrl(docUid)).then(response => response.blob());
        });
    }
    /*istanbul ignore next*/
    getFileBase64(docUid, fetchWindow = window.fetch) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getFileBlob(docUid, fetchWindow).then(convertBlobToBase64);
        });
    }
    getFileUrl(docUid) {
        return EnterpriseDocStoreService.createFileUrl(docUid);
    }
    static createFileUrl(docUid) {
        return `${EnvironmentService.getEnvironment().enterpriseDocStoreEndpoint}/documents/${docUid}?ep-eds-accessmode=EXTERNAL&access_token=${localStorage.getItem('accessToken')}`;
    }
    deleteFile(docUid) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${this.env.enterpriseDocStoreEndpoint}/documents/${docUid}`;
            const request = new Request(uri, {
                method: HttpMethodType.DELETE,
                cache: HttpCacheType.NO_CACHE
            });
            return this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
    postEdsRequest(url, payload, edsRequest, contentType) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                method: HttpMethodType.POST,
                headers: {
                    [HttpHeaderType.CONTENT_TYPE]: contentType,
                    [HttpHeaderType.XMI_REQUEST_ID]: edsRequest.correlationId,
                    [HttpHeaderType.XMI_CALLER]: edsRequest.caller
                },
                body: JSON.stringify(payload)
            };
            return this.fetchWrapper(url, request).then(response => handleResponse(response));
        });
    }
    static getFileS3URL(docUid, fetchWindow = window.fetch) {
        return fetchWindow(EnterpriseDocStoreService.createFileUrl(docUid)).then(response => handleResponseURL(response));
    }
}
//# sourceMappingURL=EnterpriseDocStoreService.js.map